// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';

const uberV2Laf: LookAndFeel = {
  code: 'uber-v2',
  displayName: 'Uber V2',
  getRootComponent: () => import('./uber-v2-root'),
  prsSupport: {
    integrations: {},
    features: [],
  },
};

export default uberV2Laf;
